<app-ci-ordered-multiselect
  [items]="items"
  [selectedIds]="selectedIds"
  [required]="required"
  [invalid]="invalid"
  [errorText]="errorText ?? ''"
  [label]="'personalData.industries' | translate"
  [placeholder]="'personalData.industriesPlaceholder' | translate"
  [searchPlaceholder]="'personalData.industriesSearch' | translate"
  [emptyLabel]="'personalData.industriesEmpty' | translate"
  [summaryTemplate]="'personalData.industriesSummary' | translate"
  [orderHeaderLabel]="'personalData.industriesOrderHeader' | translate"
  [orderHintLabel]="'personalData.orderHint' | translate"
  [emptyListLabel]="'personalData.industriesEmptyList' | translate"
  [addButtonLabel]="'request.buttons.industries' | translate"
  [dragHandleAriaLabel]="'personalData.aria.dragHandle' | translate"
  [maxItems]="maxItems"
  [clearLabel]="'ciSelect.clearSelection' | translate"
  [orderListAriaLabel]="'personalData.aria.dragDropOrderIndustriesAria' | translate"
  [showSorting]="showSorting"
  [moveUpAriaLabel]="moveUpAriaLabel"
  [moveDownAriaLabel]="moveDownAriaLabel"
  [deleteAriaLabel]="deleteAriaLabel"
  (itemsAdded)="onItemsAdded()"
  (itemsRemoved)="onItemsRemoved($event)"
  (itemRemoved)="onItemRemoved($event)"
  (itemMoved)="onItemMoved($event)"
  (maxExceeded)="onMaxExceeded($event)"
  (selectedIdsChange)="onSelectedIdsChange($event)"
  (addClicked)="onAddClick()"
></app-ci-ordered-multiselect>

<app-request-dialog
  [type]="RequestType.INDUSTRY"
  modalId="addIndustries"
  [title]="'request.buttons.industries'"
  [(visible)]="showModal"
  (existingChosen)="onExistingChosen($event)"
></app-request-dialog>
